// Simple cross-page helpers for the Biker Boulevard marketplace
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const api = {
  async valuate(payload) {
    const res = await fetch(`${API_URL}/api/valuation/estimate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Valuation failed");
    return res.json();
  },
  async uploadPhoto(file) {
    const fd = new FormData();
    fd.append("file", file);
    const res = await fetch(`${API_URL}/api/listings/photos`, { method: "POST", body: fd, credentials: "include" });
    if (!res.ok) {
      const j = await res.json().catch(() => ({}));
      throw new Error(j.detail || "Upload failed");
    }
    return res.json();
  },
  async createListing(payload) {
    const res = await fetch(`${API_URL}/api/listings`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const j = await res.json().catch(() => ({}));
      throw new Error(j.detail || "Create failed");
    }
    return res.json();
  },
  async listListings(params = {}) {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") qs.append(k, v);
    });
    const res = await fetch(`${API_URL}/api/listings?${qs.toString()}`);
    if (!res.ok) throw new Error("Fetch failed");
    return res.json();
  },
  async getListing(id) {
    const res = await fetch(`${API_URL}/api/listings/${id}`);
    if (!res.ok) throw new Error("Not found");
    return res.json();
  },
  async getFacets() {
    const res = await fetch(`${API_URL}/api/listings/filters/facets`);
    if (!res.ok) return { brands: [], states: [], cities: [] };
    return res.json();
  },
  photoUrl(photoId) {
    return `${API_URL}/api/listings/photos/${photoId}`;
  },
};

export const INR = (n) => (n == null ? "—" : `₹${Number(n).toLocaleString("en-IN")}`);
export const INR_SHORT = (n) => {
  if (n == null) return "—";
  if (n >= 1_00_00_000) return `₹${(n / 1_00_00_000).toFixed(2)} Cr`;
  if (n >= 1_00_000) return `₹${(n / 1_00_000).toFixed(2)} L`;
  if (n >= 1000) return `₹${(n / 1000).toFixed(1)} K`;
  return `₹${n}`;
};
